<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="inspectionShipments">
      <div slot="toolbar">
        <el-button
            slot="toolbar"
            type="primary"
            size="mini"
            @click="$refs.editInspectionShipment.open(0)">
          新建
        </el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="检验结果">
            <el-select v-model.trim="filter.inspectionResult" clearable placeholder="请选择">
              <el-option
                  v-for="item in constant.toSelect(constant.inspectionResult)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </vm-search>
          <vm-search label="物料号">
            <el-input v-model.trim="filter.materialNo" clearable/>
          </vm-search>
          <vm-search label="检验员">
            <el-input v-model.trim="filter.inspectorName" clearable/>
          </vm-search>
          <vm-search label="报告编号">
            <el-input v-model.trim="filter.billNo" clearable/>
          </vm-search>
          <vm-search label="检验单号">
            <el-input v-model.trim="filter.inspectionReportNo" clearable/>
          </vm-search>
          <vm-search label="创建时间">
            <div class="block">
              <el-date-picker
                  v-model="filter.beginCreateTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 165px"
                  placeholder="选择开始时间"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.endCreateTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 165px"
                  placeholder="选择结束时间"/>
            </div>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="billNo" width="150" align="center" label="报告编号"/>
      <el-table-column prop="factoryNo" align="center" label="出厂编号"/>
      <el-table-column prop="customerName" align="center" label="客户名称"/>
      <el-table-column prop="inspectorName" align="center" width="180px" label="登记人"/>
      <el-table-column prop="createdTime" align="center" width="180px" label="报告创建时间"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status===0 || editAuth" type="primary" @click="edit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <preview ref="preview" @save-success="getList(-1)"/>
    <inspection-shipment-edit ref="editInspectionShipment" @save-success="getList(-1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "../../../util/constant";
  import constants from "@/util/constants";
  import Preview from "@/views/purchase/inspectionReport/Preview";
  import InspectionShipmentEdit from "@/views/purchase/inspectionShipment/InspectionShipmentEdit";

  export default {
    components: {InspectionShipmentEdit, Preview, VmTable, VmSearch},
    data() {
      return {
        constant,
        constants,
        editAuth: this.$auth(835),
        reportStatus: constant.toSelect(constant.reportStatus, "addAll"),
        show: "",
        exportLoading: false,
        exportLoading1: false,
        submitLoading: false,
        filter: {
          filter: "",
          voucherNo: "",
          checkStatus: 0,
          deliveryNo: "",
          materialNo: "",
          inspectorName: "",
          inspectionReportNo: "",
          billNo: "",
          supplierName:"",
          inspectionResult: "",
        },
        details: [],
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      handleSearch() {
        this.getList(1);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
      },
      exportExcel() {
        this.exportLoading1 = true;
        this.$http
          .exportFile("basic", "inspectionShipments/exportInspection", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading1 = false;
          })
          .catch(() => {
            this.exportLoading1 = false;
          });
      },
      edit(row) {
        this.$refs.editInspectionShipment.open(row.pkid);
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
